import { memo, useCallback } from 'react';
import { Button, mergeClasses } from '@fluentui/react-components';
import { FlagRegular, FlagFilled } from '@fluentui/react-icons';
import { useTimeGridStyles } from '../useTimeGridStyles';

type FlagButtonProps = {
    flagged: boolean;
    onToggle: () => void;
};

export const FlagButton = memo(function FlagButton({ flagged, onToggle }: FlagButtonProps) {
    const styles = useTimeGridStyles();

    const handleClick = useCallback(
        (e: React.MouseEvent) => {
            e.stopPropagation();
            onToggle();
        },
        [onToggle],
    );

    return (
        <Button
            className={mergeClasses('fui-trigger-flag', styles.flagTrigger, flagged && styles.flagTriggerFlagged)}
            appearance="subtle"
            size="small"
            icon={flagged ? <FlagFilled /> : <FlagRegular />}
            aria-label={flagged ? 'Remove flag' : 'Add flag'}
            tabIndex={-1}
            onClick={handleClick}
        />
    );
});
